import React from 'react';
import { useAtom, useAtomValue } from 'jotai';
import type { FrameFieldT } from '../../../../../modernization-common/relationships';
import { SameIntervalSection } from '../../../../../modernization-common/relationships/components/relationship-editor';
import { isEditingAtom, sameIntervalAtom, selectedLabelAtom, sharedFrameRangeAtom } from '../../../atoms/relationship-atoms';
export const SameInterval = () => {
  const isEditing = useAtomValue(isEditingAtom);
  const selectedLabel = useAtomValue(selectedLabelAtom);
  const [sameInterval, setSameInterval] = useAtom(sameIntervalAtom);
  const [sharedFrameRange, setSharedFrameRange] = useAtom(sharedFrameRangeAtom);
  const temporalScope = selectedLabel?.temporalConstraints?.temporalScope;
  if (isEditing || !temporalScope) return null;
  const handleSharedFrameChange = (field: FrameFieldT, value: number | undefined) => setSharedFrameRange(prev => ({
    ...prev,
    [field]: value
  }));
  return <SameIntervalSection sameInterval={sameInterval} temporalScope={temporalScope} sharedFrameRange={sharedFrameRange} onSameIntervalToggle={setSameInterval} onSharedFrameChange={handleSharedFrameChange} />;
};